import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import InventorySection from './components/InventorySection';
import AboutSection from './components/AboutSection';
import ShopInfoSection from './components/ShopInfoSection';
import CtaSection from './components/CtaSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="font-noto" style={{ backgroundColor: '#1a1a1a' }}>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <InventorySection />
        <AboutSection />
        <ShopInfoSection />
        <CtaSection />
      </main>
      <SiteFooter />
    </div>
  );
}